var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "statement-descriptor-input",
      class: "" + (this.checkout ? "emd-form-group eu-flex-item" : ""),
    },
    [
      _c("label", { staticClass: "emd-label" }, [
        _vm._v(_vm._s(_vm.$t("statement_descriptor.label"))),
      ]),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.statementDescriptor,
            expression: "statementDescriptor",
          },
        ],
        staticClass: "emd-input",
        class: { _state_error: _vm.statementDescriptorFeedbackError },
        attrs: {
          type: "text",
          maxlength: _vm.max,
          disabled: _vm.isDisabled(),
          "data-testid": "input",
        },
        domProps: { value: _vm.statementDescriptor },
        on: {
          input: function ($event) {
            if ($event.target.composing) {
              return
            }
            _vm.statementDescriptor = $event.target.value
          },
        },
      }),
      _c(
        "p",
        {
          staticClass: "emd-input-feedback",
          attrs: { "data-testid": "inputFeedback" },
        },
        [_vm._v(_vm._s(_vm.$t("statement_descriptor.hint")))]
      ),
      _vm.statementDescriptorFeedbackError
        ? _c(
            "p",
            {
              staticClass: "emd-input-feedback _state_error",
              attrs: { "data-testid": "inputFeedbackError" },
            },
            [
              _vm._v(
                _vm._s(_vm.$t("statement_descriptor.error.special_characters"))
              ),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }